export default class proveedor{
	constructor($scope,
				$routeParams,
				method,
				proveedorService,
				$location,
                $uibModal,
				toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(proveedorService);
			break;
			case 'new':
				this.create(proveedorService);
			break;
			case 'view':
				this.view($routeParams,
                    proveedorService);
			break;
		}
	}

	list(proveedorService){

        let self = this.scope;

        proveedorService.getAll().then((resp, err) => {
			self.proveedores = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.proveedores.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, proveedorService);

        /*
        this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                proveedorService.delete({_id: id}).then((resp) => {
                    this.toastr.success('Proveedor eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al eliminar proveedor!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
		*/
	}

	create(proveedorService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                proveedorService.save(this.scope.proveedor).then((resp) => {
                    this.toastr.success('Proveedor creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/proveedor');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear el Proveedor!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

	view($routeParams,
         proveedorService){

		this.scope.aux = {};
        proveedorService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.proveedor = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                proveedorService.update(this.scope.proveedor).then((resp) => {
                    this.toastr.success('Proveedor modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/proveedor');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el Proveedor!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Proveedor</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar al proveedor: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.proveedores.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Proveedor eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar al proveedor!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/proveedor/proveedor.js